module.exports = __webpack_public_path__ + "apple_logo.c9890d3f48ea98522813307f5b528c24.png";